const PERMISSIONS = {};

export const VIEW_LEADERBOARD = 'VIEW_LEADERBOARD';

export default PERMISSIONS;
